// Note this file will be overwritten during the GitLab CI build process
const version = "4.5.4-88474"
const customerAgreementVersion = "2018-04-26"

export {version}
export {customerAgreementVersion}
